import vuexFactory from "@/store";
import { App } from "@vue/runtime-core";
import { createRouter, createWebHistory, Router } from "vue-router";
import tokenService from "@/utils/tokenService";
import MessageService from "@/utils/message";
import routes from "@/routes/routes";

let router: Router;

const routeFactory = {
    init: (app: App) => {
        router = createRouter({
            history: createWebHistory(process.env.VUE_APP_REQUEST_PREFIX_URL),
            routes: routes
        });
        app.use(router);
        addInterceptor(router);
    },
    getRouter(): Router {
        return router;
    }
}

const whiteList = [
    "/login"
];

const addInterceptor = (router: Router) => {
    const store = vuexFactory.getStore();
    router.beforeEach((to, from, next) => {
        if (to.fullPath === from.fullPath) {
            return;
        }
        // console.log('to:--------------%o-----------------from:%o', to, from)
        // let token = tokenService.getToken();
        // if (token !== undefined && token !== null) {
        // store.dispatch("setMenuByRoute", to);
        next();
        // } else {
        //     if (whiteList.indexOf(to.path) !== -1) {
        //         next();
        //     } else {
        //         MessageService.warn("请先登录才能访问此界面！");
        //         next("/login") // 否则全部重定向到登录页
        //     }
        // }
    })

    router.afterEach((to, from) => {
        // 多页控制 打开新的页面
        store.dispatch('open', to)
    })
}
export default routeFactory;
